module.exports = __webpack_public_path__ + "static/media/app-image.74d688ca.png";